import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinTypeOfClothing = createAsyncThunk(
    "typeOfClothing/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/TypeOfClothing/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.TypeOfClothingID,
                        label: item.TypeOfClothingName,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getTypeOfClothing = createAsyncThunk(
    "typeOfClothing/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/TypeOfClothing/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertTypeOfClothing = createAsyncThunk(
    "typeOfClothing/insert",
    async ({TypeOfClothingName}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TypeOfClothingName", TypeOfClothingName);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/TypeOfClothing/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateTypeOfClothing = createAsyncThunk(
    "typeOfClothing/update",
    async ({TypeOfClothingName, TypeOfClothingID, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TypeOfClothingName", TypeOfClothingName);
        formData.append("TypeOfClothingID", TypeOfClothingID);
        formData.append("Status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/TypeOfClothing/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const typeOfClothingSlice = createSlice({
    name: "typeOfClothing",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinTypeOfClothing.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinTypeOfClothing.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinTypeOfClothing.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getTypeOfClothing.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getTypeOfClothing.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getTypeOfClothing.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertTypeOfClothing.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertTypeOfClothing.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertTypeOfClothing.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateTypeOfClothing.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateTypeOfClothing.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateTypeOfClothing.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const typeOfClothingSelector = (state) => state.typeOfClothing;
